import { useInfiniteQuery } from "react-query";
import { useRequest } from "../../contexts/request";

const useGameVoucherGroups = ({ keyword = "", username = "", streamer_id = "", ...props } = {}) => {
  const { get } = useRequest();
  
  const fetchGroups = async (key, cursor = 0) => {
    const page = typeof cursor === 'number' ? cursor + 1 : 1;
    const params = new URLSearchParams({
      page: String(page),
      limit: '10',
    });
    if (keyword) {
      params.append('keyword', keyword);
    }
    if (username) {
      params.append('username', username);
    }
    if (streamer_id) {
      params.append('streamer_id', streamer_id);
    }
    
    const { json } = await get(`game-vouchers/groups?${params}`);
    return json.data;
  };

  const { data, canFetchMore, isFetchingMore, fetchMore, ...rest } =
    useInfiniteQuery(`gameVoucherGroups-${keyword}-${username}`, fetchGroups, {
      staleTime: 300000,
      getFetchMore: (lastPage) => {
        const { page } = lastPage;
        if (page.current < page.total) {
          return page.current;
        }
        return undefined;
      },
      ...props,
    });

  return { data, canFetchMore, isFetchingMore, fetchMore, ...rest };
};

export { useGameVoucherGroups };
